import type {
    ManifestFeatureComponentStageGfpp,
    ManifestFeatureGfppMainActionButtonConfig
} from '@wix/document-services-types'
import {pickBy} from 'lodash'
import {DisplayFiltersActions} from './DisplayFiltersActions'
import {ActionsHelpers} from '../actions/ActionsHelpers'
import type {BUILDER_COMPONENT_MAP} from '../elements/BaseElementBuilder'

export class DisplayFiltersNativeActionsBuilder extends DisplayFiltersActions {
    constructor(
        private readonly gfpp: ManifestFeatureComponentStageGfpp | undefined,
        private readonly componentType?: keyof typeof BUILDER_COMPONENT_MAP
    ) {
        super()
    }

    protected getHiddenActions = () => {
        const {iconButtons} = this.gfpp?.desktop || {}
        const hideAction: ManifestFeatureGfppMainActionButtonConfig = {
            behavior: 'HIDE'
        }

        return {
            ...ActionsHelpers.getMappedNativeActionKeys(
                ActionsHelpers.pickNativeActionValues({
                    iconButtons: iconButtons ? pickBy(iconButtons, ActionsHelpers.isActionHidden) : undefined
                })
            ),
            ...(this.componentType === 'wixui.StylableHorizontalMenu' ? {manageItems: hideAction} : {})
        }
    }
}
